import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../components/AuthProvider';
import '../../styles/admin/AdminForgotPasswordPage.css';
import AdminForgotPasswordForm from '../../forms/admin/AdminForgotPasswordForm';
import { requestUserPasswordReset } from '../../services/UserAuthService';

const AdminForgotPasswordPage = () => {
  const { userData, getCookie } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showEmailField, setShowEmailField] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (userData && userData.is_admin) {
      navigate('/admin');
    }
  }, [userData, navigate]);

  const MAX_EMAIL_LENGTH = 320;

  const handleEmailChange = (e) => setEmail(e.target.value);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validateForm = () => {
    if (!email) {
      return 'Please enter your email address.';
    }

    if (email.length > MAX_EMAIL_LENGTH) {
      return `Email cannot exceed ${MAX_EMAIL_LENGTH} characters.`;
    }

    if (!validateEmail(email)) {
      return 'Please enter a valid email address.';
    }

    return '';
  };

  const handleSubmit = async () => {
    setFormSubmitted(true);
    const validationError = validateForm();
  
    if (validationError) {
      setErrorMessage(validationError);
      return;
    }
  
    setLoading(true);
    setErrorMessage('');
    setSuccessMessage('');
  
    try {
      const csrftoken = getCookie('csrftoken');
      const result = await requestUserPasswordReset(email, csrftoken);
      if (result.success) {
        setSuccessMessage(result.message);
        setEmail('');
        setShowEmailField(false);
      } else {
        setErrorMessage(result.message);
      }
    } catch (error) {
      setErrorMessage('Error: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBackHome = () => {
    navigate('/');
  };

  return (
    <div className="admin__forgot-password-page">
      <div className="admin__modal">
        <div className="admin__modal-content">
          <div className="admin__modal-intro">
            <h2>Forgot Password</h2>
            <p>Enter your email to reset your password.</p>
          </div>
          <AdminForgotPasswordForm
            email={email}
            errorMessage={errorMessage}
            successMessage={successMessage}
            loading={loading}
            formSubmitted={formSubmitted}
            handleEmailChange={handleEmailChange}
            showEmailField={showEmailField}
          />
          <div className="admin__modal-buttons">
            <button
              className="button secondary"
              onClick={handleBackHome}
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Back Home'}
            </button>
            <button
              className="button"
              onClick={handleSubmit}
              disabled={loading || !email || !!successMessage}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminForgotPasswordPage;